import React from "react";
import { chooseDelimiter } from "./ExportWithOptions";

import { Modal, Radio } from "antd";
import { translateKey as t } from "../../../locales/translation";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

const ExportToCSV = (controller, fileName, customExport) => {
  if (!customExport) {
    customExport = fileName + " - " + dayjs().format("dd, Do MMM, YYYY - HH:mm:ss");
  }

  let columnsStructure;
  if (controller.viewMode === "card") {
    columnsStructure = Object.values(controller.hiddenTableColStructure);
  } else {
    columnsStructure = controller.tableColStructure;
  }

  const fields = constructHeaders(columnsStructure);

  chooseDelimiter(controller, customExport, fields);
};

const ExportAsExcel = (columns, data, fileName, customExport) => {
  if (!customExport) {
    customExport = fileName + " - " + dayjs().format("dd, Do MMM, YYYY - HH:mm:ss");
  }

  const fields = constructHeaders(columns);

  const parsedData = [];

  data.forEach((el) => {
    const structure = {};

    fields.forEach((field) => {
      structure[field.label] = field.value(el);
    });

    parsedData.push(structure);
  });

  let truncatedFilename = "";

  if (fileName.length > 31) {
    truncatedFilename = fileName.substring(0, 31);
  } else {
    truncatedFilename = fileName;
  }

  // Parse prepared data and generate worksheet
  const worksheet = XLSX.utils.json_to_sheet(parsedData);
  // Add it to the workbook
  const workbook = XLSX.utils.book_new();
  // Append worksheet to a workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, truncatedFilename);
  // Download the file
  XLSX.writeFile(workbook, customExport + ".xlsx", { compression: true });
};

const constructHeaders = (columns) => {
  const formattedColumns = [];

  Object.values(columns).forEach((c) => {
    formatHeader(c) && formattedColumns.push(formatHeader(c));
  });

  return formattedColumns;
};

const formatHeader = (col) => {
  let headerTitle = "";

  // If filtering disabled that means the col has buttons or actions which not needed to be exported
  // Or the column is disabled manually not to be included in the export
  if (col.disableFilters || col.disableExport) {
    return;
  }

  // Override col header if HeaderExport is defined
  // For example: You might want to render complex header with multiple elements, but for export you will need to have only string for the name
  if (col.HeaderExport) {
    headerTitle = col.HeaderExport;
  } else {
    // Override col header if the header is a function so we could apply the checks below as some functions output the tooltip component
    if (typeof col.Header === "function") {
      col.Header = col.Header();
    }

    if (typeof col.Header !== "string") {
      if (col.Header.props) {
        if (typeof col.Header.props.children === "string") {
          headerTitle = col.Header.props.children;
        } else if (typeof col.Header.props.title === "string") {
          headerTitle = col.Header.props.title;
        }
      } else {
        return;
      }
    } else {
      headerTitle = col.Header;
    }
  }

  // If header value is empty, ignore
  if (!headerTitle) {
    return;
  }

  return {
    label: headerTitle,
    value: (data) => (col.exportAccessor ? col.exportAccessor(data) : col.accessor(data)),
  };
};

function ExportToExcel(controller, fileName, customExport) {
  let exportedData = "original";

  let columnsStructure;

  if (controller.viewMode === "card") {
    columnsStructure = Object.values(controller.hiddenTableColStructure);
  } else {
    columnsStructure = controller.visibleColumns;
  }

  const isFiltered = controller.filteredColumns.length > 0 || controller.sortBy;

  if (isFiltered) {
    const options = () => {
      return (
        <div>
          <b style={{ display: "block", marginBottom: 5 }}>Export Data As</b>
          <Radio.Group defaultValue={exportedData} onChange={(e) => exportDataOnChange(e)}>
            <Radio value="original">Original</Radio>
            <Radio value="filtered">Filtered / Sorted</Radio>
          </Radio.Group>
        </div>
      );
    };

    const exportDataOnChange = (e) => {
      exportedData = e.target.value;
    };

    Modal.confirm({
      title: "Filtered / Sorted Data Detected",
      content: options(),
      centered: true,
      okText: t("lblExport", "Export"),
      cancelText: t("lblCancel", "Cancel"),
      onOk: () =>
        // ExportAsExcel(
        //   controller.visibleColumns,
        //   exportedData === "original" ? controller.tableData : controller.sortedFilteredList,
        //   fileName,
        //   customExport
        // ),
        ExportAsExcel(
          columnsStructure,
          exportedData === "original" ? controller.tableData : controller.sortedFilteredList,
          fileName,
          customExport
        ),
    });
  } else {
    ExportAsExcel(columnsStructure, controller.tableData, fileName, customExport);
    // ExportAsExcel(controller.visibleColumns, controller.tableData, fileName, customExport);
  }
}

export { ExportToCSV, ExportToExcel };
